// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
  document.getElementById("product__title__variant").innerHTML = ' - ' + evt.detail.variant.title;
  document.getElementById("reviews-short").setAttribute( "data-sku", evt.detail.variant.sku );
  document.getElementById("reviews-full").setAttribute( "data-sku", evt.detail.variant.sku );
  //document.getElementById("reviews-full").setAttribute( "data-name", evt.detail.variant.name );
  
  // Loyalty Lion Points see https://developers.loyaltylion.com/sdk/live-updating/
  document.getElementById("product-price").setAttribute( "data-lion-price-for-product-id", evt.detail.variant.id );
  document.getElementById("product-points-total").setAttribute( "data-lion-points-for-product-id", evt.detail.variant.id );
  window.loyaltylion.ui.refresh();

  //Klarna price
  window.Klarna.OnsiteMessaging.refresh();

  //Trustpilot widget updater
  const trustboxShort = document.getElementById('reviews-short');
  window.Trustpilot.loadFromElement(trustboxShort, true);
  
  const trustboxFull = document.getElementById('reviews-full');
  //window.Trustpilot.loadFromElement(trustboxFull, true);
  function tpUpdateFull() {
    window.Trustpilot.loadFromElement(trustboxFull, true);
  }
  setTimeout(tpUpdateFull, 400);

  //function tpUpdateShort() {
  //  window.Trustpilot.loadFromElement(trustboxShort, true);
  //}
  //setTimeout(tpUpdateShort, 400);

  //const trustboxFull = document.getElementById('reviews-full');
  //function tpUpdateFull() {
  //  window.Trustpilot.loadFromElement(trustboxFull, true);
  //}
  //setTimeout(tpUpdateFull, 400);
  
  //ClearPay price
  let clearPayPrice = (evt.detail.variant.price / 100); 
  //let clearPayTag = document.getElementsByTagName('afterpay-placement')[0];
  let clearPayTag = document.getElementsByTagName('square-placement')[0];
  clearPayTag.setAttribute( "data-amount", clearPayPrice );

  //extraVariantInfo used in product-block-additional-image to pass updated id. This errors when no additional image exists
  //Additional image removed
  //extraVariantInfo(evt.detail.variant.id);

});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
  const trustbox = document.getElementById('reviews-short');
  window.Trustpilot.loadFromElement(trustbox);

  //const variantSelector = document.getElementById('variant-selector').value;
  //console.log(variantSelector);
  window.loyaltylion.ui.refresh();
});
